var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticStyle:{"min-width":"16px","padding":"2px 8px"},style:(_vm.shadowStyle),attrs:{"text":"","color":_vm.buttonColor,"title":"Notificaciones"},on:{"click":_vm.openNotifications}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("notifications_none")]),_vm._v(" "+_vm._s(_vm.notificationCount || '0')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }